// src/components/AdminSidebar.jsx
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

export default function AdminSidebar() {
  const navigate = useNavigate();

  const linkClass = ({ isActive }) =>
    `block px-4 py-3 rounded-lg hover:bg-pink-50 dark:hover:bg-gray-800 transition ${
      isActive ? "bg-pink-100 dark:bg-gray-800 font-semibold" : "text-gray-700 dark:text-gray-300"
    }`;

  return (
    <aside className="w-64 bg-white dark:bg-gray-900 border-r dark:border-gray-800 p-4 h-full">
      <div className="mb-6 flex items-center gap-3 cursor-pointer" onClick={() => navigate("/")}>
        <div className="h-10 w-10 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 font-bold">BB</div>
        <div>
          <div className="font-bold text-lg text-pink-600 dark:text-pink-300">Bubble Butter</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Admin Panel</div>
        </div>
      </div>

      <nav className="space-y-2">
        <NavLink to="/admin" end className={linkClass}>
          Dashboard
        </NavLink>
        <NavLink to="/admin/orders" className={linkClass}>
          Orders
        </NavLink>
        {/* Updated Products link */}
        <NavLink to="/admin/products" className={linkClass}>
          Products
        </NavLink>
        <NavLink to="/admin/analytics" className={linkClass}>
          Analytics (placeholder)
        </NavLink>
        <NavLink to="/admin/settings" className={linkClass}>
          Settings
        </NavLink>
      </nav>
    </aside>
  );
}
